import React, { FC, SyntheticEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { AdminEntitiesManagement } from "@components/admin/entities";
import { Box, Card, CardContent, Divider, Stack } from "@components/base";
import Tabs, { TabItem } from "@components/common/Tabs";
import { PageTitle } from "@components/common";
import { EmissionFactorsTable } from "@components/admin/emissionFactors";

type Tab = "entities" | "emission-factors";

const AdminHubPage: FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<Tab>("entities");
  const { tab } = useParams<{ tab: Tab }>();
  const navigate = useNavigate();

  const tabs: TabItem<Tab>[] = [
    {
      path: "entities",
      title: t("admin.entitiesManagement.title"),
    },
    {
      path: "emission-factors",
      title: t("admin.emissionFactorsManagement.title"),
    },
  ];

  const handleTabChange = (event: SyntheticEvent, value: Tab): void => {
    navigate(`/admin/${value}`);
  };

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab]);

  return (
    <Card>
      <CardContent>
        <Stack mb={6} height="100%" flexDirection="column">
          <Box mb={3}>
            <PageTitle title="Admin" />
            <Tabs<Tab>
              tabs={tabs}
              activeTab={activeTab}
              onChange={handleTabChange}
            />
            <Divider />
          </Box>
          {activeTab === "entities" && <AdminEntitiesManagement />}
          {activeTab === "emission-factors" && <EmissionFactorsTable />}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AdminHubPage;
